import { META, SALONS } from './data';

// Footer — gallery wall caption style. Two address blocks, no marketing band.
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#F4F1EA] text-[#0A0A0A] border-t border-[#0A0A0A]/15 mt-20">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
        <div>
          <p className="font-serif text-3xl lg:text-4xl" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-serif italic text-base lg:text-lg text-[#0A0A0A]/60 mt-2">{META.tagline} &middot; established {META.est}</p>
          <p className="text-sm text-[#0A0A0A]/65 mt-6 leading-[1.7] max-w-md">A bi-national fine-art house specialising in Northern European painting (1880&ndash;1940) and modern works on paper. Two galleries, one private viewing room above each.</p>
        </div>
        {SALONS.map(s => (
          <div key={s.city}>
            <p className="font-serif italic text-2xl text-[#B53024]">{s.city}</p>
            <p className="text-sm text-[#0A0A0A]/75 mt-3 leading-[1.6]">{s.addr}</p>
            <p className="text-sm text-[#0A0A0A]/75 mt-1">{s.hours}</p>
            <p className="font-mono text-[11px] text-[#0A0A0A]/55 mt-2">{s.tel}</p>
          </div>
        ))}
      </div>
      <div className="border-t border-[#0A0A0A]/10 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A]/45">
        <span>© {new Date().getFullYear()} Halcyon & Vale Gallery · A bi-national art bureau</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('editorial')} className="hover:text-[#B53024]">Editorial</button>
          <a href="#" className="hover:text-[#B53024]">Press</a>
          <a href="#" className="hover:text-[#B53024]">Privacy</a>
        </div>
      </div>
    </footer>
  );
}
